module.exports = __webpack_public_path__ + "img/oneplus-default.70dfb51a.jpeg";